<p>event-summary works!</p>
